<div [class.lines]="lines">
  <ng-content></ng-content>
</div>
